import ConstructionCraneIcon from './ConstructionCraneIcon'

export default ConstructionCraneIcon
